import { render, staticRenderFns } from "./openIssuePcy.vue?vue&type=template&id=9332de60&scoped=true&"
import script from "./openIssuePcy.vue?vue&type=script&lang=js&"
export * from "./openIssuePcy.vue?vue&type=script&lang=js&"
import style0 from "./openIssuePcy.vue?vue&type=style&index=0&id=9332de60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9332de60",
  null
  
)

export default component.exports